<template>
  <section class="p-1">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Sanction Search</div>
        <div>
          <bread-crumb :bread-crumbs="['Sanction Search']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-form ref="sanction" v-model="valid" lazy-validation>
          <v-row class="mt-2">
            <v-col cols="12" md="2" lg="3">
              <label class="labelFontsize required my-0">Black list Name</label>
              <v-text-field
                outlined
                dense
                placeholder="Search"
                v-model="searchName"
                :rules="searchRules"
              ></v-text-field>
            </v-col>

            <v-btn
              depressed
              class="mt-6"
              small
              color="primary"
              @click="searchData"
            >
              Search
            </v-btn>
            <v-btn
              depressed
              class="mt-6 ms-3"
              outlined
              small
              color="primary"
              @click="clear()"
            >
              Clear
            </v-btn>
          </v-row>
        </v-form>
        <v-row class="mt-3">
          <v-col cols="12" md="4">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header @click="getallBlackListcount">
                  <div class="primary--text">Sources for blocklist summary</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-if="isExpanded">
                    <v-simple-table dense>
                      <template>
                        <thead>
                          <tr>
                            <th class="text-left">Source</th>
                            <th class="text-left">Records</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in countLIst" :key="item.id">
                            <td>{{ item.data_source }}</td>
                            <td>
                              <h6>
                                {{ item.count }}
                              </h6>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- <v-card color="grey lighten-5">
              <template>
                <h6 class="ms-2 primary--text">Block List Status</h6>
                <v-simple-table dense>
                  <template>
                    <thead>
                      <tr>
                        <th class="text-left">Source</th>
                        <th class="text-left">Records</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in countLIst" :key="item.id">
                        <td>{{ item.data_source }}</td>
                        <td>
                          <a
                            @click="
                              redirectToSanctionSearchResult(item.data_source)
                            "
                            class="text-decoration-underline"
                            >{{ item.count }}</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
            </v-card> -->
          </v-col>
          <!-- <v-col cols="12" md="8"
            ><v-card color="grey lighten-5">
              <template>
                <h6 class="ms-2 primary--text">
                  Recent Top Ten Sanction Updates
                </h6>
                <v-simple-table dense>
                  <template>
                    <thead>
                      <tr>
                        <th class="text-left">Updated Date</th>
                        <th class="text-left">Total Records</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>No List Available</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template> </v-card
          ></v-col> -->
        </v-row>
        <v-row class="mt-6">
          <v-col></v-col>
          <v-col></v-col>
          <v-col></v-col>
          <v-col></v-col>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            @click="downloadExcelsheet()"
            class="mr-5"
            color="primary"
            small
            ><v-icon small>mdi-file-excel-outline</v-icon>Export
          </v-btn>
        </v-row>
        <v-row class="mt-6">
          <v-col></v-col>
          <v-col></v-col>

          <v-col
            ><v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              class="me-4"
              dense
              clearable
            ></v-text-field
          ></v-col>
        </v-row>
        <v-card color="grey lighten-5" class="mt-6">
          <v-data-table
            fixed-header
            height="55vh"
            :headers="headers"
            :items="blackListname"
            :items-per-page="10"
            :search="search"
            dense
          >
            <template v-slot:item.ofacKey="{ item }">
              <v-btn
                text
                small
                color="primary"
                class="px-0 text-decoration-underline"
                :disabled="!item.ofacKey || !item.source || item.row_id == null"
                @click="openSanctionDetail(item)"
              >
                {{ item.ofacKey || "—" }}
              </v-btn>
            </template>
            <template v-slot:item.name="{ item }">
              <div
                v-html="formatNameHighlighters(item.name, highlightWord)"
              ></div>
            </template>
            <template v-slot:item.dob="{ item }">
              {{ item.dob || "—" }}
            </template>
            <template v-slot:item.address="{ item }">
              <div
                v-html="formatNameHighlighters(item.address, highlightWord)"
              ></div>
            </template>
            <template v-slot:top>
              <v-row
                no-gutters
                v-if="foundlength"
                justify="center"
                class="pt-3 pb-3"
              >
                <v-col cols="auto">
                  <b>
                    <span class="pa-1 black--text"
                      >Total match found:{{ foundlength }}</span
                    ></b
                  >
                </v-col>
              </v-row>
              <v-divider class="m-0 p-0"></v-divider>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
      <OverlayPageVue :showOverlay="loaderOverlay" />
    </v-card>
    <v-dialog
      v-model="detailDialog"
      max-width="900"
      scrollable
      persistent
      hide-overlay
    >
      <v-card color="white">
        <v-card-title>
          Sanction Detail
          <span v-if="selectedSdn" class="ml-2">{{ selectedSdn }}</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            aria-label="Close sanction detail"
            @click="closeSanctionDetail"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4 white">
          <v-progress-linear
            v-if="detailLoading"
            indeterminate
            color="primary"
          ></v-progress-linear>
          <v-alert v-else-if="detailError" type="error" dense>
            {{ detailError }}
          </v-alert>
          <template v-else>
            <div class="caption mb-3">Requested Row ID: {{ selectedRowId }}</div>
            <div v-for="(detail, index) in sanctionDetails" :key="index">
              <div v-if="sanctionDetails.length > 1" class="subtitle-1 mb-3">
                Record {{ index + 1 }}
              </div>
              <div
                v-for="(section, sectionIndex) in detailSections"
                :key="section.title"
                class="mb-4"
              >
                <div class="subtitle-2 font-weight-bold primary--text mb-2">
                  {{ section.title }}
                </div>
                <v-row dense>
                  <v-col
                    v-for="field in section.fields"
                    :key="field.value"
                    cols="12"
                    :sm="field.wide ? 12 : 6"
                    class="py-1"
                  >
                    <div class="caption grey--text text--darken-1">
                      {{ field.text }}
                    </div>
                    <div class="body-2 black--text detail-value">
                      {{ formatDetailValue(detail[field.value]) }}
                    </div>
                  </v-col>
                </v-row>
                <v-divider
                  v-if="sectionIndex < detailSections.length - 1"
                  class="mt-3"
                ></v-divider>
              </div>
              <v-divider
                v-if="index < sanctionDetails.length - 1"
                class="my-4"
              ></v-divider>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
// import axios from "axios";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import setupService from "@/services/SetupService/setupService.js";
import alerts from "@/mixins/alerts";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name: "Sanction Search",
  mixins: [alerts],
  data: () => ({
    loaderOverlay: false,
    valid: true,
    countLIst: [],
    blackListname: [],
    searchName: "",
    search: "",
    isExpanded: false,
    foundlength: null,
    detailDialog: false,
    detailLoading: false,
    detailError: "",
    detailRequestId: 0,
    selectedSdn: "",
    selectedRowId: null,
    sanctionDetails: [],
    detailSections: [
      {
        title: "Record",
        fields: [
          { text: "Row ID", value: "row_id" },
          { text: "SDN No", value: "ofacKey" },
          { text: "Source", value: "source" },
          { text: "Name", value: "name", wide: true },
          { text: "Also Known As", value: "aka", wide: true },
        ],
      },
      {
        title: "Identification",
        fields: [
          { text: "Date of Birth", value: "dob" },
          { text: "Nationality", value: "nationality" },
          { text: "ID Type", value: "id_type" },
          { text: "ID Number", value: "id_number", wide: true },
        ],
      },
      {
        title: "Location",
        fields: [{ text: "Addresses", value: "addresses", wide: true }],
      },
      {
        title: "Additional Information",
        fields: [
          { text: "Remarks", value: "remarks", wide: true },
          { text: "Entity Number", value: "ent_num" },
          { text: "Vessel Type", value: "vessel_type" },
          { text: "Created Date", value: "created_date" },
        ],
      },
    ],
    headers: [
      {
        text: "SDN No",
        value: "ofacKey",
        width: "100",
      },
      { text: "Name", value: "name", width: "100" },
      { text: "DOB", value: "dob", width: "120" },
      { text: "ID Type", value: "id_type", width: "100" },
      { text: "ID Number", value: "id_number", width: "150" },
      { text: "Nationality", value: "nationality", width: "100" },
      { text: "Address", value: "address", width: "100" },
      { text: "Remarks", value: "remarks", width: "200" },
      { text: "Source", value: "source", width: "100" },
    ],
  }),
  components: {
    OverlayPageVue,
    BreadCrumb,
  },
  computed: {
    searchRules() {
      return [
        (value) => !!value || "Search field is required",
        // (value) =>
        //   (value && value.length >= 3) ||
        //   "Search term must be at least 3 characters long",
      ];
    },
  },

  mounted() {},
  methods: {
    formatDetailValue(value) {
      if (Array.isArray(value)) {
        return value.length ? value.join("\n") : "—";
      }
      return value === null || value === undefined || value === ""
        ? "—"
        : value;
    },
    async openSanctionDetail(item) {
      const requestId = ++this.detailRequestId;
      this.selectedSdn = item.ofacKey;
      this.selectedRowId = item.row_id;
      this.sanctionDetails = [];
      this.detailError = "";
      this.detailLoading = true;
      this.detailDialog = true;

      try {
        const response = await setupService.getSanctionDetail(
          item.source,
          item.row_id
        );
        if (requestId !== this.detailRequestId) return;

        const details = response.data.data;
        if (
          response.data.status_code === 200 &&
          Array.isArray(details) &&
          details.length
        ) {
          this.sanctionDetails = details;
        } else {
          this.detailError =
            response.data.status_code === 200
              ? "No sanction details found."
              : response.data.message || "Unable to load sanction details.";
        }
      } catch (error) {
        if (requestId !== this.detailRequestId) return;
        this.detailError = "Unable to load sanction details. Please try again.";
      } finally {
        if (requestId === this.detailRequestId) this.detailLoading = false;
      }
    },
    closeSanctionDetail() {
      this.detailRequestId += 1;
      this.detailDialog = false;
      this.selectedRowId = null;
      this.sanctionDetails = [];
      this.detailError = "";
      this.detailLoading = false;
    },
    formatNameHighlighters(val, highlightWord) {
      console.log(highlightWord);
      const wordsList = Array.isArray(highlightWord)
        ? highlightWord
        : [highlightWord];

      if (val && wordsList.length > 0) {
        const regex = new RegExp(wordsList.join("|"), "gi");
        return val.replace(
          regex,
          (match) =>
            `<mark><strong class="error--text">${match}</strong></mark>`
        );
      }
      return val;
    },

    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.blackListname) {
        this.exportToExcel(this.headers, this.blackListname, "blackListname");
      }
    },
    // async getexcel() {
    //   if (this.blackListname.length > 0) {
    //     try {
    //       const responseData = await axios.get(
    //         `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/blacklist/get-blacklist-excel-data?datasource=MOF`,
    //         {
    //           headers: {
    //             ContentType: "application/json",
    //             accept: "application/json",
    //             "content-type":
    //               "application / vnd.openxmlformats -officedocument.spreadsheetml.sheet",
    //           },
    //         },
    //         { responseType: "arraybuffer" }
    //       );
    //       console.log("responseData", responseData.request.responseURL);
    //       const url = responseData.request.responseURL;
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", "excel.xlsx");
    //       document.body.appendChild(link);
    //       link.click();
    //     } catch (error) {
    //       return error;
    //     }
    //   }
    // },
    async getallBlackListcount() {
      if (!this.isExpanded) {
        this.loaderOverlay = true;
        try {
          const response = await setupService.getCount();
          if (response.data.status_code === 200) {
            this.countLIst = response.data.data;
            this.stoploader();
          }
          // else if (response.data.status_code === 401) {
          //   this.countLIst = [];
          //   this.returnNewToken();
          //   this.getallBlackListcount();
          //   this.stoploader();
          // }
          else {
            this.countLIst == [];
            this.stoploader();
          }
        } catch (error) {
          this.countLIst = [];
          this.stoploader();
          console.error(error);
        }
        this.isExpanded = !this.isExpanded;
      }
    },
    async searchData() {
      this.highlightWord = this.searchName;
      console.log("venkatesh", this.highlightWord);
      const validate = this.$refs.sanction.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const responseData = await setupService.Searchlist(this.searchName);
          this.blackListname = responseData.data.data;
          console.log("this.blackListname", this.blackListname);
          this.foundlength = this.blackListname.length;
          if (responseData && responseData.data.status_code === 200) {
            this.stoploader();
            this.showAlertSuccess(responseData.data.message);
          }
          // else if (responseData.data.status_code == 401) {
          //   this.returnNewToken();
          //   this.searchData();
          // }
          else {
            this.showAlertError(responseData.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },

    // async getallSearchResult(item) {
    //   this.loaderOverlay = true;
    //   const dataSource = item.data_source;
    //   try {
    //     const response = await setupService.getSearchresult(dataSource);
    //     if (response.data.status_code === 200) {
    //       this.blackListname = response.data.data;
    //       this.foundlength = null;
    //       this.stoploader();
    //     }
    //     // else if (response.data.status_code === 401) {
    //     //   this.blackListname = [];
    //     //   this.returnNewToken();
    //     //   this.getallSearchResult();
    //     //   this.stoploader();
    //     // }
    //     else {
    //       this.blackListname == [];
    //       this.stoploader();
    //     }
    //   } catch (error) {
    //     this.blackListname = [];
    //     this.stoploader();
    //     console.error(error);
    //   }
    // },
    clear() {
      this.searchName = "";
      this.blackListname = [];
      this.foundlength = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.bgprimary {
  background-color: $primary;
}
.detail-value {
  overflow-wrap: anywhere;
  white-space: pre-line;
}
</style>
